export default __webpack_public_path__ + "static/coop-logo-3eb3192a11af528bc3c11e51ef935b89.png";